import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14 1.333H2a.667.667 0 1 0 0 1.334h2V14a.666.666 0 0 0 .667.667h4A.666.666 0 0 0 9.333 14v-3.333h2A.666.666 0 0 0 12 10V2.667h2a.666.666 0 1 0 0-1.334m-6 12H5.333V2.667H8zm2.667-4H9.333V2.667h1.334z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })